export const SET_SAI_NUMBER = 'SET_SAI_NUMBER';
export const SET_SCANNED_QUERY = 'SET_SCANNED_QUERY';
